import { PriceBillingCycleArray } from "app/models/ss-api/price.billing.cycle";

export interface IPublicOrderProductsResponse {

  ProductID: number;
  Name: string;
  Prices: PriceBillingCycleArray;
  YardAddon: IPublicOrderProductsResponse;
  VisiblePublic: boolean;
  TaxEnabled: boolean;
  YardVisiblePublic: boolean;
}

export class PublicOrderProductsResponse implements IPublicOrderProductsResponse {

  ProductID: number;
  Name: string;
  Prices: PriceBillingCycleArray;
  YardAddon: PublicOrderProductsResponse;
  VisiblePublic: boolean;
  TaxEnabled: boolean;
  YardVisiblePublic: boolean;
}

export class PublicOrderProductsResponseArray extends Array<PublicOrderProductsResponse> {

  constructor(...items: PublicOrderProductsResponse[]) {
    super(...items);
    Object.setPrototypeOf(this, PublicOrderProductsResponseArray.prototype);
  }

}
